import SearchMatchingSection from '../../../sections/AdminDashboard/Configuration/SearchMatching';

const SearchMatching = () => <SearchMatchingSection />;

export default SearchMatching;
